<template>
  <div>
    <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler">
      <bm-marker :position="center" :dragging="drag" animation="BMAP_ANIMATION_BOUNCE">
        <bm-label :content="tip" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -90, height: 30}"/>
      </bm-marker>
    </baidu-map>
  </div>
</template>

<script>
    export default {
        name: "MapView",
        props:['mapInfo'],
        data (){
          return{
            center:{lng:0,lat:0},
            zoom:15,
            tip:"",
            drag:false
          }
        },
      methods:{
        handler({BMap,map}){
            this.center.lng = this.mapInfo.position.lng;
            this.center.lat = this.mapInfo.position.lat;
            this.zoom = this.mapInfo.zoom;
            this.tip = this.mapInfo.tip;
            this.drag = this.mapInfo.dragg;
          }
      }
    }
</script>

<style scoped>
  .map {
    width: 100%;
    height: 414px;
  }
</style>
